import {
  CLOSE_BOARD,
  FETCH_EXERCISES_START,
  FETCH_EXERCISES_FULFILLED,
  FETCH_EXERCISES_REJECTED,
  FETCH_GROUPS_START,
  FETCH_GROUPS_FULFILLED,
  FETCH_GROUPS_REJECTED,
  FETCH_LEADERBOARD_START,
  FETCH_LEADERBOARD_FULFILLED,
  FETCH_LEADERBOARD_REJECTED,
  EDIT_LEADERBOARD_START,
  EDIT_LEADERBOARD_FULFILLED,
  EDIT_LEADERBOARD_REJECTED,
  SET_MODAL_OPEN,
  SET_LEADERBOARD_VIEW,
  SET_ACTIVE_FILTERS,
  CLEAR_ALL_BOARDS,
  SET_TV_MODE,
  FETCH_TEMPLATES_START,
  FETCH_TEMPLATES_FULFILLED,
  FETCH_TEMPLATES_REJECTED,
  SAVE_TEMPLATE_START,
  SAVE_TEMPLATE_FULFILLED,
  SAVE_TEMPLATE_REJECTED,
  UPDATE_TEMPLATE_START,
  UPDATE_TEMPLATE_FULFILLED,
  UPDATE_TEMPLATE_REJECTED,
  DELETE_TEMPLATE_START,
  DELETE_TEMPLATE_FULFILLED,
  DELETE_TEMPLATE_REJECTED,
} from './actionTypes';

const initialState = {
  activeBoardId: 0,
  activeBoards: 0,
  activeModal: '',
  activeFilters: { groups: [] },
  editingTemplateId: null,
  isLoadingExercises: false,
  isLoadingGroups: true,
  isLoadingLeaderboard: false,
  isLoadingTemplates: false,
  templatesInitialized: false,
  isTemplateSavingDeleting: false,
  isModalOpen: false,
  isTvMode: false,
  leaderboards: {},
  view: 'home',
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_EXERCISES_START: {
      return {
        ...state,
        isLoadingExercises: true,
      };
    }
    case FETCH_EXERCISES_FULFILLED: {
      return {
        ...state,
        isLoadingExercises: false,
      };
    }
    case FETCH_EXERCISES_REJECTED: {
      return {
        ...state,
        isLoadingExercises: false,
      };
    }
    case FETCH_GROUPS_START: {
      return {
        ...state,
        isLoadingGroups: true,
      };
    }
    case FETCH_GROUPS_FULFILLED: {
      return {
        ...state,
        isLoadingGroups: false,
      };
    }
    case FETCH_GROUPS_REJECTED: {
      return {
        ...state,
        isLoadingGroups: false,
      };
    }
    case FETCH_LEADERBOARD_START: {
      return {
        ...state,
        isLoadingLeaderboard: true,
      };
    }
    case FETCH_LEADERBOARD_FULFILLED: {
      return {
        ...state,
        activeBoards: state.activeBoards + 1,
        isLoadingLeaderboard: false,
        view: 'leaderboard',
      };
    }
    case FETCH_LEADERBOARD_REJECTED: {
      return {
        ...state,
        isLoadingLeaderboard: false,
      };
    }
    case EDIT_LEADERBOARD_START: {
      return {
        ...state,
        isLoadingLeaderboard: true,
      };
    }
    case EDIT_LEADERBOARD_FULFILLED: {
      return {
        ...state,
        isLoadingLeaderboard: false,
      };
    }
    case EDIT_LEADERBOARD_REJECTED: {
      return {
        ...state,
        isLoadingLeaderboard: false,
      };
    }
    case CLOSE_BOARD: {
      const newActiveBoards = state.activeBoards !== 0 ? state.activeBoards - 1 : 0;
      return {
        ...state,
        activeBoards: newActiveBoards,
        view: newActiveBoards === 0 ? 'home' : 'leaderboard',
      };
    }
    case SET_MODAL_OPEN: {
      return {
        ...state,
        activeBoardId: action.payload.activeBoardId,
        activeModal: action.payload.activeModal,
        isModalOpen: action.payload.isModalOpen,
      };
    }
    case SET_LEADERBOARD_VIEW: {
      return {
        ...state,
        view: action.payload.view,
        editingTemplateId: action.payload.editingTemplateId || null,
      };
    }
    case SET_ACTIVE_FILTERS: {
      return {
        ...state,
        activeFilters: action.payload,
      };
    }
    case SET_TV_MODE: {
      return {
        ...state,
        isTvMode: action.payload,
      };
    }
    case FETCH_TEMPLATES_START: {
      return { ...state, isLoadingTemplates: true };
    }
    case FETCH_TEMPLATES_FULFILLED: {
      return { ...state, isLoadingTemplates: false, templatesInitialized: true };
    }
    case FETCH_TEMPLATES_REJECTED: {
      return { ...state, isLoadingTemplates: false };
    }
    case SAVE_TEMPLATE_START: {
      return { ...state, isTemplateSavingDeleting: true };
    }
    case SAVE_TEMPLATE_FULFILLED: {
      return { ...state, isTemplateSavingDeleting: false };
    }
    case SAVE_TEMPLATE_REJECTED: {
      return { ...state, isTemplateSavingDeleting: false };
    }
    case UPDATE_TEMPLATE_START: {
      return { ...state, isTemplateSavingDeleting: true };
    }
    case UPDATE_TEMPLATE_FULFILLED: {
      return { ...state, isTemplateSavingDeleting: false };
    }
    case UPDATE_TEMPLATE_REJECTED: {
      return { ...state, isTemplateSavingDeleting: false };
    }
    case DELETE_TEMPLATE_START: {
      return { ...state, isTemplateSavingDeleting: true };
    }
    case DELETE_TEMPLATE_FULFILLED: {
      return { ...state, isTemplateSavingDeleting: false };
    }
    case DELETE_TEMPLATE_REJECTED: {
      return { ...state, isTemplateSavingDeleting: false };
    }
    case CLEAR_ALL_BOARDS: {
      return {
        ...state,
        activeBoards: 0,
        view: 'home',
      };
    }
    default: {
      return state;
    }
  }
}
